
import { Button, Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import { controlla, risposteSondaggiIcon } from '../../../utilities/icone'


/*
PROPS
<AzioniTabellaSondaggio
    sonId={sondaggio.sonId}
    setSonId={props.setSonId}
    stato={sondaggio.sonStato}
    setMostraTabella={props.setMostraTabella}
    setGestisci={props.setGestisci}
/>
*/
export default function AzioniTabellaSondaggio(props){

    const handleClick = (gestisci) => {
        props.setMostraTabella(false)
        props.setSonId(props.sonId)
        props.setGestisci(gestisci)
    }

    return(
        <Container className="d-flex justify-content-around p-0 m-0">
            <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>Controlla</Tooltip>}
            >
                <Button
                    variant="noBackground"
                    onClick={()=> {handleClick("controlla-sondaggio")}}
                >
                    {controlla}
                </Button>
            </OverlayTrigger>
            <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>Risposte</Tooltip>}
            >
                <Button
                    variant="noBackground"
                    onClick={() => { handleClick("visualizza-risposte") }}
                >
                    {risposteSondaggiIcon}
                </Button>
            </OverlayTrigger>
        </Container>
    )
}